import { render } from "./GeneticMatches.vue?vue&type=template&id=6af2d78e&scoped=true"
import script from "./GeneticMatches.vue?vue&type=script&lang=js"
export * from "./GeneticMatches.vue?vue&type=script&lang=js"

import "./GeneticMatches.vue?vue&type=style&index=0&id=6af2d78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af2d78e"]])

export default __exports__